import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import MobileFrame from '../components/MobileFrame';
import Lottie from "lottie-react";
import successAnimation from '../assets/sucess.json';
import rejectedAnimation from '../assets/rejected.json';
import { proceedToLenderJourney } from '../services/preApprovalService';


// Success animation component using Lottie
const SuccessIcon: React.FC = () => (
  <div className="w-40 h-40 mx-auto mb-8">
    <Lottie animationData={successAnimation} loop={true} />
  </div>
);

// Error animation component using Lottie
const ErrorIcon: React.FC = () => (
  <div className="w-40 h-40 mx-auto mb-8">
    <Lottie animationData={rejectedAnimation} loop={true} />
  </div>
);

const Response: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isApproved, setIsApproved] = useState<boolean | null>(null);
  const [creditLimit, setCreditLimit] = useState<number>(0);
  const [lender, setLender] = useState<string>('');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [errorDetails, setErrorDetails] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [orderId, setOrderId] = useState<string>('');

  useEffect(() => {
    // Check if we have pre-approval data from state
    const preApprovalData = location.state?.preApprovalResult;

    if (preApprovalData) {
      // New flow with pre-approval service
      setIsApproved(preApprovalData.amount > 0);
      setCreditLimit(preApprovalData.amount || 0);
      setLender(preApprovalData.lender || 'Unknown');

      // Store scheme information if available
      // if (preApprovalData.schemeSelected) {
      //   setSchemeSelected(preApprovalData.schemeSelected);
      // }
    } else {
      // Legacy flow with URL params
      const status = searchParams.get('status');
      const limit = searchParams.get('limit');
      // const schemeParam = searchParams.get('schemeSelected');

      if (status === 'approved') {
        setIsApproved(true);
        setCreditLimit(limit ? parseInt(limit) : 20000);
        // if (schemeParam) {
        //   setSchemeSelected(schemeParam);
        // }
      } else if (location.state?.message) {
        // Error message from redirect
        setIsApproved(false);
        setErrorDetails(location.state.details || 'No offer available at this time.');
      } else {
        setIsApproved(false);
      }
    }

    // Try to get from sessionStorage if not in URL or location state
    const storedResult = sessionStorage.getItem('preApprovalResult');
    if (!preApprovalData && !searchParams.get('status') && storedResult) {
      try {
        const parsedResult = JSON.parse(storedResult);

        // Handle both response formats - standard format with nested data and direct format
        if (parsedResult.Amount !== undefined) {
          // Direct format (Amount, Message, Lender)
          setIsApproved(parsedResult.Amount > 0);
          setCreditLimit(parsedResult.Amount || 0);
          setLender(parsedResult.Lender || 'Unknown');
        } else {
          // Standard format
          setIsApproved(parsedResult.amount > 0);
          setCreditLimit(parsedResult.amount || 0);
          setLender(parsedResult.lender || 'Unknown');
          setOrderId(parsedResult.orderId || '');
        }
      } catch (e) {
        // console.error('Error parsing stored pre-approval result:', e);
      }
    }

    // If coming from location state, extract orderId
    if (preApprovalData?.orderId) {
      setOrderId(preApprovalData.orderId);
    }
  }, [searchParams, location]);

  // Handle window resize to determine if mobile view should be shown
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Add this useEffect inside your Response component, after your other useEffects
useEffect(() => {
  if (isApproved === false) {
    // Clear all sensitive session storage on rejection
    sessionStorage.removeItem('token');
    
  }
}, [isApproved]);


  const handleProceed = async () => {
    if (!isApproved) {
      // Clear session storage
      clearSessionStorage();

      // Get callback URL from sessionStorage
      const callbackUrl = sessionStorage.getItem('callbackUrl') || '';

      if (callbackUrl) {
        // Redirect to callback URL
        window.location.href = callbackUrl;
      } else {
        // Fallback if callback URL is missing
        alert('Unable to proceed. Please close this tab.');
      }

      return;
    }


    // Get the pre-approval result from session storage
    const preApprovalResult = sessionStorage.getItem('preApprovalResult');
    const transactionResult = sessionStorage.getItem('transactionData');
    let preApprovalData;
    let transacationdata;

    try {
      preApprovalData = preApprovalResult ? JSON.parse(preApprovalResult) : null;
    } catch (e) {
      // console.error('Error parsing pre-approval result:', e);
      preApprovalData = null;
    }
    try {
      transacationdata = transactionResult ? JSON.parse(transactionResult) : null;
    } catch (e) {
      // console.error('Error parsing TransacationData result:', e);
      transacationdata = null;
    }

    if (!preApprovalData) {
      alert('Pre-approval data not found. Please try again.');
      navigate('/login');
      return;
    }
    if (!transacationdata) {
      alert('Transacation data not found. Please try again.');
      navigate('/login');
      return;
    }


    // Store the necessary data in session storage for EMI Tenure page
    sessionStorage.setItem('approvedAmount', creditLimit.toString());
    sessionStorage.setItem('lenderName', lender);
    console.log('trasactiondataaaaaaaaaaaaaaaaaaaaa', transacationdata);
 
    // Navigate to EMI Tenure page instead of directly to lender
    navigate('/emi-tenure', {
      state: {
        transactionData: transacationdata,
        orderId: orderId || transacationdata.orderId,
        lender: transacationdata.lender,
        partner : transacationdata.partnerName,
      }
    });
  };

  const clearSessionStorage = () => {
    // Clear session storage
    sessionStorage.removeItem('preApprovalResult');
    sessionStorage.removeItem('transactionResult');
    sessionStorage.removeItem('mobileNumber');
  };


  const ResponseContent = () => (
    <div className="flex flex-col h-full">

      <div className="flex flex-col items-center justify-center flex-1">
        {isApproved ? (
          // Approved Screen
          <>
            <SuccessIcon />
            <h1 className="mb-2 text-2xl font-bold text-center text-gray-900 dark:text-white">Congratulations!</h1>
            <p className="mb-4 text-center text-gray-600 dark:text-gray-400">You are eligible for a credit limit of</p>

            <div className="relative mb-6">
              <div className="px-10 py-3 border-2 rounded-full border-emerald-500 dark:border-emerald-400">
                <p className="text-3xl font-bold text-gray-900 dark:text-white">₹{creditLimit.toLocaleString()}</p>
              </div>
              <div className="absolute w-2 h-2 transform -translate-y-1/2 bg-red-500 rounded-full -left-1 top-1/2"></div>
              <div className="absolute w-2 h-2 transform -translate-y-1/2 bg-red-500 rounded-full -right-1 top-1/2"></div>
            </div>
          </>
        ) : (
          // Rejected Screen
          <>
            <ErrorIcon />
            <h1 className="mb-2 text-2xl font-bold text-center text-gray-900 dark:text-white">Offer Unavailable</h1>
            <p className="mb-4 text-center text-gray-600 dark:text-gray-400">Currently not Eligible for credit limit</p>

            {/* {errorDetails && (
              <p className="mb-12 text-sm text-center text-gray-500 dark:text-gray-400">{errorDetails}</p>
            )} */}
          </>
        )}
      </div>

      <div className="mt-auto">
        {/* Powered by CleverPe */}
        <div className="flex items-center justify-center mb-4">
          <img
            src="/CleverPeLogos/PoweredBy.svg"
            alt="Powered By CleverPe"
            className="h-10"
            onError={(e) => {
              e.currentTarget.src = 'https://cleverpe.com';
            }}
          />
        </div>

        {/* Proceed button */}
        <button
          onClick={handleProceed}
          disabled={isLoading}
          className={`w-full py-3 text-lg font-semibold text-center text-white transition rounded-full 
            ${isLoading ? 'bg-gray-400 dark:bg-gray-700' : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-md active:scale-[0.97]'}`}
        >
          {isLoading ? 'Processing...' : (isApproved ? 'Proceed' : 'Close')}
        </button>
      </div>
    </div>
  );

  return isMobile ? (
    <div className="h-[100dvh] w-full p-5 overflow-hidden bg-white dark:bg-dark">
      <ResponseContent />
    </div>
  ) : (
    <MobileFrame>
      <ResponseContent />
    </MobileFrame>
  );
};

export default Response; 